const ar: Record<string, any> = {
  // General
  appName: 'منارة',
  appNameAr: 'منارة',
  appNameEn: 'MANARA',
  slogan: 'كلية المنارة',
  switchLang: 'עברית',
  logout: 'تسجيل خروج',
  save: 'حفظ',
  cancel: 'إلغاء',
  add: 'إضافة',
  edit: 'تعديل',
  delete: 'حذف',
  search: 'بحث...',
  actions: 'إجراءات',
  status: 'الحالة',
  loading: 'جاري التحميل...',
  noData: 'لا توجد بيانات للعرض',
  export: 'تصدير',
  exportExcel: 'تصدير إلى Excel',
  exportPDF: 'تصدير إلى PDF',
  filter: 'تصفية',
  all: 'الكل',
  close: 'إغلاق',
  confirm: 'تأكيد',
  back: 'رجوع',
  details: 'تفاصيل',
  name: 'الاسم',
  email: 'البريد الإلكتروني',
  phone: 'الهاتف',
  address: 'العنوان',
  date: 'التاريخ',
  notes: 'ملاحظات',
  send: 'إرسال',

  // Sidebar
  dashboard: 'لوحة التحكم',
  students: 'الطلاب',
  tasks: 'المهام',
  courses: 'المساقات',
  lecturers: 'المحاضرون',
  finance: 'المالية',
  communication: 'التواصل',
  leads: 'العملاء المحتملون',
  reports: 'التقارير',
  settings: 'الإعدادات',
  schedule: 'الجدول الزمني',

  // Dashboard
  activeStudents: 'طلاب نشطون',
  activeCourses: 'مساقات نشطة',
  newLeads: 'عملاء محتملون جدد',
  monthlyRevenue: 'إيرادات الشهر',
  urgentTasks: 'مهام عاجلة',
  todayEvents: 'أحداث اليوم',
  revenueChart: 'مخطط الإيرادات',
  upcomingEvents: 'أحداث قادمة',
  shekel: '₪',

  // Students
  studentList: 'قائمة الطلاب',
  addStudent: 'إضافة طالب',
  firstName: 'الاسم الأول',
  lastName: 'اسم العائلة',
  dateOfBirth: 'تاريخ الميلاد',
  nationalId: 'رقم الهوية',
  city: 'البلدة',
  program: 'البرنامج/المساق',
  enrollmentDate: 'تاريخ التسجيل',
  studentStatus: 'حالة الطالب',
  candidate: 'مرشح',
  approved: 'معتمد',
  active: 'نشط',
  frozen: 'مجمد',
  graduated: 'تخرج',
  enrolledCourses: 'المساقات المسجلة',
  grades: 'العلامات',
  payments: 'المدفوعات',
  commHistory: 'سجل التواصل',
  sendEmail: 'إرسال بريد إلكتروني',
  sendWhatsApp: 'إرسال WhatsApp',

  // Documents
  documents: 'المستندات',
  uploadDocument: 'رفع مستند',
  docType: 'نوع المستند',
  fileName: 'اسم الملف',
  uploadDate: 'تاريخ الرفع',
  viewDoc: 'عرض',
  downloadDoc: 'تحميل',
  deleteDoc: 'حذف',
  docTypes: {
    id_card: 'بطاقة هوية',
    bagrut: 'شهادة الثانوية',
    prev_studies: 'شهادة دراسات سابقة',
    medical: 'تقرير طبي',
    passport_photo: 'صورة جواز السفر',
    registration_contract: 'عقد التسجيل',
    receipt: 'إيصال',
    other: 'أخرى',
  },

  // Courses
  courseList: 'قائمة المساقات',
  addCourse: 'إضافة مساق',
  courseCode: 'رمز المساق',
  courseName: 'اسم المساق',
  lecturer: 'المحاضر',
  semester: 'الفصل',
  academicYear: 'السنة الأكاديمية',
  maxStudents: 'الحد الأقصى للطلاب',
  enrolled: 'مسجلون',
  price: 'السعر',
  room: 'القاعة',
  weeklySchedule: 'الجدول الأسبوعي',
  enrollStudent: 'تسجيل طالب',
  attendance: 'الحضور',

  // Days
  sunday: 'الأحد',
  monday: 'الاثنين',
  tuesday: 'الثلاثاء',
  wednesday: 'الأربعاء',
  thursday: 'الخميس',
  friday: 'الجمعة',
  saturday: 'السبت',

  // Lecturers
  lecturerList: 'قائمة المحاضرين',
  addLecturer: 'إضافة محاضر',
  specialization: 'التخصص',
  contractType: 'نوع العقد',
  hourlyRate: 'أجر الساعة',
  fullTime: 'دوام كامل',
  partTime: 'دوام جزئي',

  // Finance
  paymentList: 'قائمة المدفوعات',
  addPayment: 'إضافة دفعة',
  amount: 'المبلغ',
  paidAmount: 'المبلغ المدفوع',
  paymentStatus: 'حالة الدفع',
  paid: 'مدفوع',
  partial: 'جزئي',
  debt: 'دين',
  paymentMethod: 'طريقة الدفع',
  bankTransfer: 'تحويل بنكي',
  creditCard: 'بطاقة ائتمان',
  cash: 'نقدي',
  check: 'شيك',
  receiptNumber: 'رقم الإيصال',
  scholarships: 'منح وتخفيضات',
  paymentReminder: 'تذكير بالدفع',
  totalRevenue: 'إجمالي الإيرادات',
  totalDebt: 'إجمالي الديون',

  // Communication
  sendMessage: 'إرسال رسالة',
  messageType: 'نوع الرسالة',
  emailMessage: 'بريد إلكتروني',
  whatsappMessage: 'WhatsApp',
  recipient: 'المستلم',
  subject: 'الموضوع',
  message: 'الرسالة',
  template: 'قالب',
  templates: {
    payment_reminder: 'تذكير بالدفع',
    enrollment_confirmation: 'تأكيد التسجيل',
    schedule_update: 'تحديث الجدول',
    general: 'رسالة عامة'
  },
  sendToGroup: 'إرسال لمجموعة',
  messageHistory: 'سجل الرسائل',
  scheduledMessages: 'رسائل مجدولة',

  // Leads
  leadsList: 'قائمة العملاء المحتملين',
  addLead: 'إضافة عميل محتمل',
  interest: 'مجال الاهتمام',
  source: 'مصدر الوصول',
  stage: 'المرحلة',
  followUpDate: 'تاريخ المتابعة',
  convertToStudent: 'تحويل إلى طالب',
  stages: {
    interested: 'مهتم',
    contacted: 'تم التواصل',
    meeting_scheduled: 'تم تحديد موعد',
    meeting_attended: 'حضر الاجتماع',
    applied: 'قدم طلب',
    enrolled: 'مسجل',
    active_student: 'طالب نشط'
  },
  sources: {
    facebook: 'فيسبوك',
    website: 'الموقع',
    referral: 'توصية',
    fair: 'معرض',
    whatsapp: 'واتساب',
    other: 'أخرى'
  },
  conversionReport: 'تقرير التحويل',

  // Prospects (المهتمون)
  prospects: 'المهتمون',
  prospectsList: 'قائمة المهتمين',
  addProspect: 'إضافة مهتم',
  requestedProgram: 'البرنامج المطلوب',
  prospectEntryDate: 'تاريخ الدخول',
  branch: 'الفرع',
  programNotes: 'ملاحظات البرنامج',
  personalInfo: 'المعلومات الشخصية',
  followUpsTab: 'ملاحظات ومتابعة',
  addCommunication: 'إضافة تواصل',
  addFollowUp: 'إضافة متابعة',
  handler: 'المسؤول',
  actionTaken: 'الإجراء المتخذ',
  nextStep: 'الخطوة التالية',
  convertToLead: 'تحويل إلى عميل محتمل',
  convertToProspect: 'تحويل إلى مهتم',
  confirmConvertToStudent: 'هل تريد تحويل هذا المهتم إلى طالب؟ سيتم نقل جميع البيانات والمستندات.',
  confirmConvertLeadToProspect: 'هل تريد تحويل هذا العميل المحتمل إلى مهتم؟',
  confirmConvertToLead: 'هل تريد إرجاع هذا المهتم إلى قائمة العملاء المحتملين؟',
  activeProspects: 'مهتمون نشطون',
  prospectStatuses: {
    initial_contact: 'اتصال أولي',
    in_process: 'قيد الاستفسار',
    documents_submitted: 'قدم مستندات',
    waiting_approval: 'بانتظار الموافقة',
    approved_for_registration: 'تمت الموافقة للتسجيل',
    rejected: 'مرفوض',
    registered: 'مسجل',
  },

  // Action Performer
  performedBy: 'تم بواسطة',
  actionPerformer: 'منفذ العملية',

  // Reports
  reportStudents: 'تقرير الطلاب النشطين',
  reportRevenue: 'تقرير الإيرادات',
  reportAttendance: 'تقرير الحضور',
  reportGrades: 'تقرير العلامات',
  reportLecturers: 'تقرير المحاضرين والساعات',
  reportLeads: 'تقرير العملاء المحتملين والتحويلات',

  // Settings
  systemSettings: 'إعدادات النظام',
  userManagement: 'إدارة المستخدمين',
  collegeSettings: 'إعدادات الكلية',
  semesterManagement: 'إدارة الفصول',
  collegeName: 'اسم الكلية',
  branches: 'الفروع',
  role: 'الدور',
  admin: 'مدير',
  secretary: 'سكرتيرة',
  username: 'اسم المستخدم',
  password: 'كلمة المرور',

  // Schedule
  time: 'الوقت',
  day: 'اليوم',

  // Billing & Payments
  billingSettings: 'الفواتير والمدفوعات',
  shakedSettings: 'إعدادات شقد (أمر دائم)',
  placardSettings: 'إعدادات بلاكارد (بطاقة ائتمان)',
  terminalNumber: 'رقم الطرفية',
  apiKey: 'مفتاح API',
  apiUrl: 'عنوان API',
  testConnection: 'اختبار الاتصال',
  connectionSuccess: 'الاتصال ناجح!',
  connectionFailed: 'فشل الاتصال',
  chargeCard: 'تحصيل دفعة ببطاقة ائتمان',
  createStandingOrder: 'إنشاء أمر دائم',
  sendPaymentLink: 'إرسال رابط دفع',
  installments: 'عدد الأقساط',
  description: 'الوصف',
  monthlyAmount: 'المبلغ الشهري',
  collectionDay: 'يوم التحصيل',
  numberOfMonths: 'عدد الأشهر',
  bankAccount: 'الحساب البنكي',
  bankNumber: 'رقم البنك',
  branchNumber: 'رقم الفرع',
  accountNumber: 'رقم الحساب',
  accountHolder: 'صاحب الحساب',
  paymentLinkUrl: 'رابط الدفع',
  copyLink: 'نسخ الرابط',
  sendViaWhatsApp: 'إرسال عبر واتساب',
  sendViaEmail: 'إرسال عبر البريد',
  billingHistory: 'سجل الفواتير',
  transactionId: 'رقم العملية',
  transactionType: 'نوع العملية',
  success: 'نجح',
  failed: 'فشل',
  pending: 'قيد الانتظار',
  collectPayment: 'تحصيل دفعة',
  createOrder: 'إنشاء أمر دائم',
  sendLink: 'إرسال رابط دفع',
  paymentPage: 'صفحة الدفع',
  payNow: 'ادفع الآن',
  cardNumber: 'رقم البطاقة',
  expiryDate: 'تاريخ الانتهاء',
  cvv: 'CVV',
  cardHolderName: 'اسم صاحب البطاقة',
  paymentSuccess: 'تم الدفع بنجاح!',
  paymentFailed: 'فشل الدفع',

  // Digital Signatures
  digitalSignatures: 'التوقيع الرقمي',
  sendForSignature: 'إرسال للتوقيع',
  signerName: 'اسم الموقّع',
  signerEmail: 'بريد الموقّع',
  signerPhone: 'هاتف الموقّع',
  attachedMessage: 'رسالة مرفقة',
  selectDocument: 'اختيار مستند',
  signatureTracking: 'متابعة التوقيعات',
  sentTo: 'أُرسل إلى',
  sentDate: 'تاريخ الإرسال',
  signatureDate: 'تاريخ التوقيع',
  signed: 'موقّع',
  expired: 'منتهي',
  signPage: 'صفحة التوقيع',
  drawSignature: 'ارسم توقيعك',
  fullName: 'الاسم الكامل',
  idNumber: 'رقم الهوية',
  signAndConfirm: 'وقّع وأكّد',
  clearSignature: 'مسح التوقيع',
  signatureSuccess: 'تم توقيع المستند بنجاح!',
  documentToSign: 'مستند للتوقيع',

  // Accounting
  accounting: 'المحاسبة',
  createInvoice: 'إصدار فاتورة',
  createReceipt: 'إصدار إيصال',
  invoice: 'فاتورة ضريبية',
  invoiceReceipt: 'فاتورة ضريبية - إيصال',
  receiptDoc: 'إيصال',
  quote: 'عرض سعر',
  transactionDoc: 'حساب صفقة',
  docNumber: 'رقم المستند',
  customerName: 'اسم العميل',
  customerAddress: 'عنوان العميل',
  customerPhone: 'هاتف العميل',
  customerEmail: 'بريد العميل',
  customerIdNumber: 'رقم السجل التجاري',
  lineItems: 'تفاصيل البنود',
  itemDescription: 'الوصف',
  quantity: 'الكمية',
  unitPrice: 'سعر الوحدة',
  lineTotal: 'المجموع',
  addLine: 'إضافة سطر',
  totalBeforeVat: 'المجموع قبل ض.ق.م',
  vat: 'ض.ق.م 17%',
  totalWithVat: 'المجموع شامل ض.ق.م',
  allDocuments: 'جميع المستندات',
  revenueReportMonthly: 'تقرير إيرادات شهري',
  revenueReportYearly: 'تقرير إيرادات سنوي',
  newDocument: 'مستند جديد',
  sendToCustomer: 'إرسال للعميل',
  year: 'السنة',
  month: 'الشهر',
  total: 'المجموع',
  count: 'العدد',

  // VoicEnter
  externalConnections: 'الاتصالات الخارجية',
  voicenterSettings: 'إعدادات VoicEnter',
  voicenterCustomerId: 'رقم عميل VoicEnter',
  voicenterApiKey: 'مفتاح API',
  voicenterApiUrl: 'عنوان API',
  voicenterMainPhone: 'رقم الهاتف الرئيسي (خط صادر)',
  callNow: 'اتصل',
  callHistory: 'المكالمات',
  calls: 'المكالمات',
  todayCalls: 'مكالمات اليوم',
  scheduleCallBtn: 'جدولة مكالمة',
  listenRecording: 'الاستماع للتسجيل',
  callTime: 'الوقت',
  callDuration: 'مدة المكالمة',
  calledBy: 'المتصل',
  callDirection: 'الاتجاه',
  callStatus: 'حالة المكالمة',
  outgoing: 'صادرة',
  incoming: 'واردة',
  answered: 'تم الرد',
  no_answer: 'لم يرد',
  busy: 'مشغول',
  initiated: 'جاري الاتصال',
  scheduled: 'مجدولة',
  phoneCall: 'مكالمة هاتفية',
  scheduleCallTitle: 'جدولة مكالمة',
  scheduledDate: 'التاريخ',
  scheduledTime: 'الوقت',
  callInitiated: 'بدأت المكالمة!',
  callScheduled: 'تم جدولة المكالمة بنجاح!',
  incomingCallFrom: 'مكالمة واردة من',
  unknownCaller: 'رقم غير معروف',
  sec: 'ثا',
  documentName: 'اسم المستند',
  documentNamePlaceholder: 'مثال: اتفاقية دراسة',
  signatureMessagePlaceholder: 'رسالة ترفق مع طلب التوقيع',
  signHere: 'وقّع هنا',
  resend: 'إعادة إرسال',
  document: 'مستند',
  signedDate: 'تاريخ التوقيع',

  // Registration Forms
  registrationForms: 'نماذج التسجيل',
  sendRegistrationForm: 'إرسال نموذج تسجيل',
  registrationFormSent: 'تم إرسال نموذج التسجيل بنجاح!',

  // Business core — Scheduling conflicts
  conflictTitle: 'تعارض في الجدول الأسبوعي',
  conflictLecturer: 'المحاضر مشغول بدرس آخر في هذا الوقت',
  conflictRoom: 'القاعة مشغولة في هذا الوقت',
  conflictWith: 'تعارض مع',
  saveAnyway: 'احفظ على أي حال',
  noConflicts: 'لا توجد تعارضات',
  checkingConflicts: 'جاري فحص التعارضات...',

  // Business core — Receipt on payment / PDF
  createReceiptPrompt: 'تم تسجيل الدفعة. هل تريد إنشاء إيصال؟',
  createReceiptYes: 'إنشاء إيصال',
  receiptCreated: 'تم إنشاء الإيصال',
  downloadPdf: 'تحميل PDF',
  viewPdf: 'عرض PDF',
  generatingPdf: 'جاري إنشاء PDF...',

  // Business core — Revenue grouping
  revenueBy: 'الإيرادات حسب',
  byMonth: 'حسب الشهر',
  bySemester: 'حسب الفصل',
  byCourse: 'حسب المساق',
  linkToCourse: 'ربط بمساق',

  // Business core — Payment provider
  paymentProvider: 'مزود الدفع',
  chargeApproved: 'تمت الموافقة على الدفع',
  chargeDeclined: 'تم رفض الدفع',

  // UX growth — Recruitment funnel
  recruitmentFunnel: 'قمع التجنيد',
  funnelRegistrations: 'نماذج مقدّمة',
  funnelStudents: 'طلاب هذا العام',
  conversion: 'تحويل',
  currentYearLabel: 'العام الدراسي',

  // UX growth — KPI trends
  vsLastMonth: 'مقارنة بالشهر السابق',
  trendUp: 'ارتفاع',
  trendDown: 'انخفاض',

  // UX growth — Needs attention
  needsAttention: 'يتطلب معالجة',
  leadsNoFollowup: 'عملاء بدون متابعة (أكثر من 3 أيام)',
  paymentsOverdue: 'دفعات تجاوزت موعدها',
  tasksOverdue: 'مهام متأخرة',
  registrationsPending: 'نماذج أُرسلت ولم تُقدّم',
  openRecord: 'فتح',
  sendReminder: 'إرسال تذكير',
  allClear: 'كل شيء منظم! لا عناصر تتطلب معالجة',
  remaining: 'المتبقي',

  // UX growth — Empty states
  noItemsYet: 'لا توجد بيانات هنا بعد',
  emptyStudents: 'لم تتم إضافة طلاب بعد',
  emptyLeads: 'لم تتم إضافة عملاء بعد',
  emptyProspects: 'لم تتم إضافة مهتمين بعد',
  emptyTasks: 'لم تتم إضافة مهام بعد',
  emptyCourses: 'لم تتم إضافة مساقات بعد',
  emptyPayments: 'لم تُسجّل دفعات بعد',
  createFirst: 'أنشئ العنصر الأول',

  // UX growth — Global search & quick add
  globalSearchPlaceholder: 'بحث عن طالب / عميل / مهتم...',
  searchNoResults: 'لا توجد نتائج',
  quickAdd: 'إضافة سريعة',
  quickAddLead: 'عميل جديد',
  quickAddTask: 'مهمة جديدة',
  quickAddStudent: 'طالب جديد',

  // UX growth — Sidebar groups
  groupMarketing: 'التسويق والتسجيل',
  groupAcademic: 'الأكاديمية',
  groupManagement: 'الإدارة',

  // UX growth — Lecturer portal
  lecturerPortal: 'بوابة المحاضر',
  myCourses: 'مساقاتي',
  enterAttendance: 'إدخال الحضور',
  enterGrades: 'إدخال العلامات',
  selectSession: 'اختر الجلسة',
  saveAttendance: 'حفظ الحضور',
  saveGrades: 'حفظ العلامات',
  grade: 'علامة',
  present: 'حاضر',
  absent: 'غائب',
  noCoursesAssigned: 'لم يتم تخصيص مساقات لك',
  nextSession: 'جلستي القادمة',
  noUpcomingSession: 'لا توجد جلسة قريبة',

  // UX growth v2 — KPI cards
  openLeads: 'عملاء مفتوحون',
  collectionThisMonth: 'التحصيل هذا الشهر',
  openTasks: 'مهام مفتوحة',
  overdueShort: 'متأخرة',
  noFollowupShort: 'بدون متابعة',
  candidatesShort: 'مرشحون',
  quickAddProspect: 'مهتم جديد',
};

export default ar;
